import { MenuItem } from './menu.model';
import { ApiserviceService } from 'src/app/core/services/apiservice.service';

export const MENU:MenuItem[] =[
 
    {
        id: 1,
        label: 'ANA MENU',
        isTitle: true
    },
  
    {
        id: 2,
        label: 'Anasayfa',
        link: '',
        icon:'bx-home'
    },
    {
        id: 3,
        label: 'Gelirler',
        link: '/gelirler',
        icon:'bx-edit'
    },
     {
        id: 5,
        label: 'Giderler',
        link: '/giderler',
        icon:'bx-edit'
    },
    {
        id: 4,
        label: 'Üyeler',
        link: '/uyeler',
        icon:'bx-user'
    },
   
       {
        id: 5,
        label: 'Ayarlar',
        link: '/ayarlar',
        icon:'bx-receipt',
        
    },
       {
        id: 6,
        label: 'SATIN AL',
        link: '/sepet',
        icon:'bx-basket',
        badge: {
            variant: 'danger',
            text: 'Yeni'
        }   
        
    },

];
